import { useMutation, useQueryClient } from 'libs/query'
import { useTranslation } from 'libs/i18n'
import { useAxiosPrivate, useToast } from 'shared/hooks'
import { queryKeys } from 'config/queryKeys'

export const useBulkDeleteMutation = (checkedTags: number[], onSettled: () => void) => {
	const { t } = useTranslation()
	const axiosPrivate = useAxiosPrivate()
	const queryClient = useQueryClient()

	const { mutate: bulkDeleteMutation } = useMutation({
		mutationFn: () => {
			// TODO: change to apiRoutes
			return axiosPrivate.post('/tags/bulk_delete/', { ids: checkedTags })
		},
		onSuccess: () => {
			useToast({
				type: 'success',
				message: t('Tag deleted')
			})()

			queryClient.invalidateQueries({ queryKey: queryKeys.tags.all })
		},
		onError: () => {
			useToast({
				type: 'error',
				message: t('Something went wrong')
			})()
		},
		onSettled: () => {
			onSettled()
		}
	})

	return {
		bulkDeleteMutation
	}
}
